import { FiDownload } from 'react-icons/fi'
import { vccBtn } from '@shared/ui/vccButtons'
import { vccButtonLabel, type VccActionButtonProps } from './vccButtonProps'

export type ExportButtonProps = VccActionButtonProps

export default function ExportButton({
  onClick,
  disabled,
  type = 'button',
  className = '',
  showIcon = true,
  loading = false,
  loadingLabel = 'Exporting...',
  label = 'Export',
  children,
  ...rest
}: ExportButtonProps) {
  return (
    <button
      type={type}
      className={`${vccBtn('export')} ${className}`.trim()}
      onClick={onClick}
      disabled={disabled || loading}
      {...rest}
    >
      {showIcon && !loading && <FiDownload aria-hidden className="vcc-btn__icon" />}
      {vccButtonLabel({ children, label, loading, loadingLabel }, label)}
    </button>
  )
}
